import { __awaiter } from 'tslib';

const KOUSSA_ENDPOINT = 'auth/token';
function refreshAuthToken(gateway, params, customURL = null, customHeaders = null, isKoussa = true) {
    return __awaiter(this, void 0, void 0, function* () {
        return gateway.post(refreshAuthToken.koussaEndpoint, {}, params, customURL, customHeaders, 'json', true);
    });
}
refreshAuthToken.koussaEndpoint = KOUSSA_ENDPOINT;

export { refreshAuthToken as default };
//# sourceMappingURL=refreshAuthToken.js.map
